/**
 * Firebase実装のトランスクリプトリポジトリ
 */

import {
  doc,
  getDoc,
  updateDoc,
  Timestamp
} from 'firebase/firestore';
import { ITranscriptRepository } from '@/repositories/interfaces';
import { getFirestoreInstance } from '@/lib/firebase';
import { FirebaseMapRepository } from './FirebaseMapRepository';

/**
 * Firebase実装のトランスクリプトリポジトリクラス
 */
export class FirebaseTranscriptRepository implements ITranscriptRepository {
  private db = getFirestoreInstance();
  
  /**
   * コンストラクタ
   * @param mapRepository マップリポジトリの参照
   */
  constructor(private mapRepository: FirebaseMapRepository) {}

  /**
   * トランスクリプトを取得
   */
  public async getTranscript(mapId: string): Promise<string | null> {
    try {
      const map = await this.mapRepository.getMap(mapId);
      if (!map) {
        return null;
      }
      
      return map.transcript;
    } catch (error) {
      console.error('Error getting transcript:', error);
      throw error;
    }
  }

  /**
   * ユーザープロジェクトのトランスクリプトを取得
   */
  public async getUserProjectTranscript(userId: string, projectId: string): Promise<string | null> {
    try {
      const projectDoc = await getDoc(doc(this.db, `users/${userId}/projects`, projectId));
      
      if (projectDoc.exists()) {
        const data = projectDoc.data();
        return data.transcript || '';
      }
      
      return null;
    } catch (error) {
      console.error('Error getting user project transcript:', error);
      throw error;
    }
  }

  /**
   * トランスクリプトを更新
   */
  public async updateTranscript(mapId: string, transcript: string): Promise<boolean> {
    try {
      await this.mapRepository.updateMap(mapId, { transcript });
      return true;
    } catch (error) {
      console.error('Error updating transcript:', error);
      throw error;
    }
  }

  /**
   * ユーザープロジェクトのトランスクリプトを更新
   */
  public async updateUserProjectTranscript(
    userId: string,
    projectId: string,
    transcript: string
  ): Promise<boolean> {
    try {
      const projectRef = doc(this.db, `users/${userId}/projects`, projectId);
      
      await updateDoc(projectRef, { 
        transcript, 
        updatedAt: Timestamp.now() 
      });
      
      return true;
    } catch (error) {
      console.error('Error updating user project transcript:', error);
      throw error;
    }
  }
}